import validate from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/validate.js";
import trailing_45slash_45global from "/vercel/path0/middleware/trailingSlash.global.ts";
import manifest_45route_45rule from "/vercel/path0/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  trailing_45slash_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}